/* ══════════════════════════════════════════════════════════════
   Earnings Calendar — Monthly Calendar with Result Dates
   ══════════════════════════════════════════════════════════════ */

export interface EarningsEvent {
    date: number;
    companies: Array<{ name: string; symbol: string; impact: 'high' | 'medium' | 'low' }>;
}

export function renderEarningsCalendar(container: HTMLElement, month?: string, events?: EarningsEvent[]): void {
    const mon = month || 'February 2026';
    const data: EarningsEvent[] = events || [
        { date: 3, companies: [{ name: 'Bajaj Finance', symbol: 'BAJFINANCE', impact: 'high' }] },
        { date: 5, companies: [{ name: 'SBI', symbol: 'SBIN', impact: 'high' }, { name: 'L&T', symbol: 'LT', impact: 'high' }] },
        { date: 10, companies: [{ name: 'Asian Paints', symbol: 'ASIANPAINT', impact: 'medium' }] },
        { date: 12, companies: [{ name: 'Titan', symbol: 'TITAN', impact: 'medium' }] },
        { date: 15, companies: [{ name: 'Nestle', symbol: 'NESTLEIND', impact: 'medium' }] },
        { date: 20, companies: [{ name: 'Tata Motors', symbol: 'TATAMOTORS', impact: 'high' }] },
        { date: 25, companies: [{ name: 'Sun Pharma', symbol: 'SUNPHARMA', impact: 'medium' }] },
    ];

    const eventMap = new Map<number, EarningsEvent>();
    data.forEach(e => eventMap.set(e.date, e));
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const startDay = new Date(2026, 1, 1).getDay(); // Feb 2026

    let calGrid = days.map(d => `<div class="cal-header">${d}</div>`).join('');
    for (let i = 0; i < startDay; i++) calGrid += '<div class="cal-empty"></div>';
    for (let d = 1; d <= 28; d++) {
        const ev = eventMap.get(d);
        const hasEvent = !!ev;
        const impactDot = ev ? ev.companies.some(c => c.impact === 'high') ? '🔴' : '🟡' : '';

        calGrid += `
      <div class="cal-day ${hasEvent ? 'has-event' : ''} ${d === new Date().getDate() ? 'today' : ''}">
        <span class="day-num">${d}</span>
        ${hasEvent ? `<span class="day-event">${impactDot} ${ev!.companies.map(c => c.symbol).join(', ')}</span>` : ''}
      </div>`;
    }

    container.innerHTML = `
    <div class="earnings-calendar glass-card">
      <div class="card-header"><h3>📅 Earnings Calendar</h3><span class="cal-month">${mon}</span></div>
      <div class="cal-grid">${calGrid}</div>
      <div class="cal-legend">
        <span>🔴 High Impact</span><span>🟡 Medium Impact</span>
      </div>
    </div>`;
}
